<div class="course">
	<h2>{{grabacion?.description}}</h2>
</div>

<div>
	<h1>Abandonaste la sesion</h1>
	<p>Puedes cerrar la ventana.</p>
  </div>